// Browser history (back/forward) support for the Turbo-Frame mission search.
//
// Turbo Drive is disabled globally (see entrypoints/site.js), so when the
// search form / filter panel navigate the results frame with
// `data-turbo-action="advance"`, Turbo pushes a history entry (the URL reflects
// the active query) but never restores it on back/forward.
//
// Because the search form and filter panel live *outside* the results frame, a
// frame-only restore would leave their inputs out of sync with the URL. Doing a
// full reload for the popped URL yields the fully correct, server-rendered
// state (form values, checked filters and results) for whichever search the
// user navigated to.
//
// `popstate` only fires for same-document history entries — i.e. the
// advance-pushed search URLs — so cross-document back/forward (e.g. leaving the
// search page entirely) is unaffected and navigates normally.

let historyReady = false

const markReady = () => {
  historyReady = true
}

// Guard against the legacy Safari behaviour of firing `popstate` on the initial
// page load, which would otherwise cause a reload loop. Only react to pops that
// happen after the page has finished loading.
if (document.readyState === `complete`) {
  markReady()
} else {
  window.addEventListener(`load`, markReady, { once: true })
}

window.addEventListener(`popstate`, () => {
  if (!historyReady) return
  // Only relevant on the mission search page (where the results frame exists).
  if (!document.getElementById(`missions_search_results`)) return

  window.location.reload()
})
